import React from 'react';
import { VStack } from '@chakra-ui/react';
import AsyncSelect from 'react-select/async';
import { tRPCProxyClient } from '../../utils/trpc';
import { UiKit } from '@datavant/uikit';

export type TenantOption = { label: string | undefined; value: string | null };

type ReusableTenantSelectProps = {
    label: string;
    description?: string;
    value: TenantOption | null;
    onChange: (value: TenantOption | null) => void;
    onInputChange?: (input: string) => void;
    defaultOptions?: TenantOption[];
    width?: string;
};

export const TenantSearch: React.FC<ReusableTenantSelectProps> = ({
    label,
    description,
    value,
    onChange,
    onInputChange,
    defaultOptions = [],
    width = '400px',
}) => {
    const loadOptions = async (input: string) => {
        const results = await tRPCProxyClient.datavanter.tenant.tenantSearch.query({
            tenantStr: input?.length ? input : null,
        });

        return results.map(result => ({
            label: `[${result.tenantTypes}] ${result.tenantName}\n${result.tenantUuid}`,
            value: result.tenantUuid,
        }));
    };

    return (
        <VStack spacing={UiKit.consistency.halfBuffer} align="start">
            <UiKit.Text.BodyRegularBold>{label}</UiKit.Text.BodyRegularBold>
            {description && <UiKit.Text.BodySmall>{description}</UiKit.Text.BodySmall>}
            <AsyncSelect
                menuPlacement="bottom"
                isMulti={false}
                value={value}
                onChange={onChange}
                onInputChange={onInputChange}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isSearchable={true}
                isClearable={false}
                menuPosition="fixed"
                styles={{
                    option: base => ({
                        ...base,
                        whiteSpace: 'pre-wrap',
                    }),
                    control: styles => ({
                        ...styles,
                        width,
                    }),
                }}
                loadOptions={loadOptions}
                defaultOptions={defaultOptions}
                loadingMessage={() => 'Loading...'}
            />
        </VStack>
    );
};
